import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import RestApi from "../../Apis/RestApi";
import { toast } from "react-toastify";
import qrOne from '../../Assets/QRCode (10).png';
import qrTwo from '../../Assets/QRCode (11).png';
import qrThird from '../../Assets/QRCode (12).png';
import qrFour from '../../Assets/QRCode (6).png';
import qrFive from '../../Assets/QRCode (7).png';
import qrSix from '../../Assets/QRCode (8).png';
import qrSeven from '../../Assets/QRCode (9).png';
import qrEight from '../../Assets/QRCode (13).png';

function ProUpgradeCard() {
  const navigate = useNavigate(); // React Router navigate hook
  const user_id = localStorage.getItem("_id");
  const user_email = localStorage.getItem("email");
  
  // Add loading state
  const [isLoading, setIsLoading] = useState(false);
  
  // Get current subscription from localStorage and convert to proper case
  const formatSubscriptionType = (type) => {
    if (!type) return "";
    
    // Handle uppercase subscription types (converting to proper case)
    switch(type.toUpperCase()) {
      case "FREE": return "Free";
      case "GROWTH": return "Growth";
      case "PREMIUM": return "Premium";
      case "ENTERPRISE": return "Enterprise";
      default: return type; // Return as is if doesn't match known types
    }
  };
  
  const current_subscription = formatSubscriptionType(localStorage.getItem("type") || "");
  
  // State for selected plan and billing cycle
  const [selectedOption, setSelectedOption] = useState(current_subscription || "Growth");
  const [billingCycle, setBillingCycle] = useState("annually"); // Default to annual billing
  const [amount, setAmount] = useState(() => {
    // Set initial amount based on current subscription and annual billing
    switch(current_subscription) {
      case "Free": return 0;
      case "Growth": return 348;
      case "Premium": return 2388;
      case "Enterprise": return null;
      default: return 348; // Default to Growth plan
    }
  });
  
  const first_login = localStorage.getItem("first_login") === "true";
  const username = localStorage.getItem("username");

  // Plan pricing configuration
  const planPricing = {
    Free: { monthly: 0, annually: 0 },
    Growth: { monthly: 99, annually: 1099 }, // Annual is ~$29/month
    Premium: { monthly: 199, annually: 2199 }, // Annual is ~$199/month
    Enterprise: { monthly: null, annually: null }
  };

  const handleSelection = (option) => {
    setSelectedOption(option);
    updateAmount(option, billingCycle);
  };
  
  const handleBillingCycleChange = (cycle) => {
    setBillingCycle(cycle);
    updateAmount(selectedOption, cycle);
  };
  
  const updateAmount = (plan, cycle) => {
    setAmount(planPricing[plan][cycle]);
  };
  
  const imgArray = [
    {name: qrOne},
    {name: qrTwo},
    {name: qrThird},
    {name: qrFour},
    {name: qrFive},
    {name: qrSix},
    {name: qrSeven},
    {name: qrEight}
  ];

  const handleContinue = async () => {
    // Set loading state to true when button is clicked
    setIsLoading(true);
    
    try {
      // If user selected the same plan they already have, just navigate back
      if (selectedOption === current_subscription) {
        toast.info("You are already subscribed to this plan");
        navigate("/home");
        return;
      }
      
      if (selectedOption === "Free") {
        // Handle free plan
        const data = {
          user_id,
          user_email,
          plan_selected: "Free",
          amount: 0,
          currency: "INR"
        };
        const response = await RestApi.initiateSubscription(data);
        // Update localStorage with new subscription type
        localStorage.setItem("type", "Free");
        toast.success("Free plan activated successfully");
        navigate("/home");
      } else if (selectedOption === "Enterprise") {
        // Handle enterprise
        const data = {
          user_id,
          user_email,
          plan_selected: "Enterprise",
          amount: 0,
          currency: "INR",
          billing_cycle: billingCycle
        };
        const response = await RestApi.initiateSubscription(data);
        toast.success("Please check Settings Screen for contact info. Thank You");
        navigate("/home/settings");
      } else {
        // Handle paid subscriptions
        const data = {
          user_id,
          user_email,
          amount,
          plan_selected: selectedOption,
          currency: "INR",
          billing_cycle: billingCycle
        };

        const orderData = await RestApi.initiateSubscription(data);
        const { id: order_id, amount: order_amount } = orderData.data.data.paymentObj;
        
        const options = {
          key: process.env.RAZORPAY_ID,
          amount: order_amount,
          currency: "INR",
          name: "Smart QR Codes",
          description: `${selectedOption} Subscription (${billingCycle})`,
          order_id: order_id,
          handler: async (response) => {
            const signature = response.razorpay_signature || 'TEST_SIGNATURE';
            try {
              setIsLoading(true); // Keep loading state while verifying
              const verifyResponse = await RestApi.verifyAndActivateSubscription({
                order_id,
                payment_id: response.razorpay_payment_id,
                signature: signature,
                user_id
              });
              if (verifyResponse.status === 200) {
                // Update localStorage with new subscription type
                localStorage.setItem("type", selectedOption);
                toast.success("Subscription activated successfully");
                navigate("/home");
              } else {
                toast.error("Subscription verification failed");
                setIsLoading(false);
              }
            } catch (error) {
              console.error("Verification error:", error);
              toast.error("Failed to verify subscription");
              setIsLoading(false);
            }
          },
          prefill: {
            name: username,
            email: user_email,
            contact: "**********",
          },
          modal: {
            ondismiss: function() {
              setIsLoading(false); // Reset loading state if payment modal is dismissed
            }
          }
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      }

      // Update first login status if it's the user's first login
      if (first_login) {
        try {
          const updateData = {
            id: user_id,
            update_obj: { first_login: false }
          };
          const response = await RestApi.updateUser(updateData);
          
          if (response.status) {
            localStorage.setItem("first_login", "false");
            toast.success("Welcome To Smart QR Codes");
          }
        } catch (updateError) {
          console.error("Error updating first login status:", updateError);
          // Don't set loading to false here as we've already navigated away in most cases
        }
      }
    } catch (error) {
      console.error("Subscription process error:", error);
      toast.error("Failed to process subscription");
      setIsLoading(false); // Reset loading state on error
    } finally {
      // Reset loading state for cases that don't navigate away
      // Free plan and same plan cases handle loading state separately
      if (selectedOption !== "Free" && selectedOption !== current_subscription && selectedOption !== "Enterprise") {
        // Don't reset loading here as Razorpay modal will take over
        // For these plans, we reset in the ondismiss handler or on error
      } else {
        setIsLoading(false);
      }
    }
  };

  // Handle the close action (navigate to the previous page)
  const handleClose = () => {
    navigate("/home"); // Go back to the previous page
  };

  // Get plan features based on selected option
  const getPlanFeatures = () => {
    switch(selectedOption) {
      case "Free":
        return (
          <>
            <li>✅ 2 QR Codes/month</li>
            <li>✅ 5 links/month</li>
            <li>✅ 2 custom landing pages</li>
            <li>✅ 3 custom back-halves/month</li>
            <li>✅ Unlimited clicks & QR Code scans</li>
            <li>✅ QR Code customizations</li>
            <li>❌ No advanced features</li>
          </>
        );
      case "Growth":
        return (
          <>
            <li>✅ 10 QR Codes/month</li>
            <li>✅ 500 links/month</li>
            <li>✅ 10 custom landing pages</li>
            <li>✅ 4 months of click & scan data</li>
            <li>✅ Complimentary custom domain</li>
            <li>✅ Branded links</li>
            <li>✅ Bulk link shortening</li>
            <li>✅ UTM Builder</li>
            <li>✅ Advanced QR Code customizations</li>
          </>
        );
      case "Premium":
        return (
          <>
            <li>✅ 200 QR Codes/month</li>
            <li>✅ 3,000 links/month</li>
            <li>✅ 20 custom landing pages</li>
            <li>✅ 1 year of click & scan data</li>
            <li>✅ Custom campaign-level tracking</li>
            <li>✅ City-level and device type click & scan data</li>
            <li>✅ Mobile deep linking</li>
            <li>✅ Everything in Growth, plus above features</li>
          </>
        );
      case "Enterprise":
        return (
          <>
            <li>✅ Unlimited QR Codes</li>
            <li>✅ Custom solution for enterprise needs</li>
            <li>✅ Dedicated account manager</li>
            <li>✅ Custom integration options</li>
            <li>✅ Premium support</li>
            <li>✅ Advanced analytics</li>
            <li>✅ Custom branding options</li>
          </>
        );
      default:
        return (<li>Please select a plan</li>);
    }
  };

  // Calculate the savings for annual billing
  const getAnnualSavings = (plan) => {
    if (plan === "Free" || plan === "Enterprise") return null;
    
    const monthlyTotal = planPricing[plan].monthly * 12;
    const annualTotal = planPricing[plan].annually;
    const savings = (monthlyTotal - annualTotal);
    
    return savings > 0 ? `Save ${savings} with annual billing` : null;
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900 text-white overflow-y-auto">
      <div className="relative bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-4xl animate-float">
        {/* Close Button */}
        {!first_login && (
          <button
            className="absolute top-4 right-4 text-white bg-gray-700 hover:bg-gray-600 p-2 rounded-full"
            onClick={handleClose}
          >
            {/* Cross Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}

        <div className="grid grid-cols-4 gap-2 mb-6">
          {/* QR Code Samples */}
          {imgArray.map((img, index) => (
            <div key={index} className="h-30 w-full bg-gray-600">
              <img src={img.name} alt="samples"/>
            </div>
          ))}
        </div>
        
        <h1 className="text-2xl font-bold mb-4">Upgrade to Premium Plans</h1>
        
        {/* Billing cycle toggle */}
        <div className="flex justify-center mb-6">
          <div className="bg-gray-700 p-1 rounded-lg flex">
            <button
              className={`px-4 py-2 rounded ${
                billingCycle === "monthly" ? "bg-[#620984] text-white" : "text-gray-300"
              }`}
              onClick={() => handleBillingCycleChange("monthly")}
            >
              Monthly
            </button>
            <button
              className={`px-4 py-2 rounded ${
                billingCycle === "annually" ? "bg-[#620984] text-white" : "text-gray-300"
              }`}
              onClick={() => handleBillingCycleChange("annually")}
            >
              Annually <span className="text-xs">Save 20%</span>
            </button>
          </div>
        </div>
        
        <ul className="mb-6 space-y-2">
          {getPlanFeatures()}
        </ul>
        
        <div>
          {/* Free Option */}
          <div
            className={`flex items-center justify-between space-x-2 mb-6 p-4 rounded-lg cursor-pointer ${
              selectedOption === "Free" ? "bg-[#620984]" : ""
            }`}
            onClick={() => handleSelection("Free")}
          >
            <div className="text-lg font-semibold">Free</div>
            <div className="text-lg font-semibold">₹0 /month</div>
          </div>

          {/* Growth Option (Recommended) */}
          <div
            className={`flex items-center justify-between space-x-2 mb-6 p-4 rounded-lg cursor-pointer ${
              selectedOption === "Growth" ? "bg-[#620984]" : ""
            }`}
            onClick={() => handleSelection("Growth")}
          >
            <div className="text-lg font-semibold relative">
              Growth
              <span className="absolute -top-4 right-0 bg-white text-blue-900 text-xs px-2 py-1 rounded">Recommended</span>
            </div>
            <div>
              <div className="text-lg font-semibold">
              ₹{(planPricing.Growth[billingCycle === "monthly" ? "monthly" : "annually"] / (billingCycle === "monthly" ? 1 : 12)).toFixed(2)} /month
              </div>
              {billingCycle === "annually" && (
                <div className="text-sm">(annual charge of ₹{planPricing.Growth.annually.toFixed(2)})</div>
              )}
              {getAnnualSavings("Growth") && billingCycle === "annually" && (
                <div className="text-xs text-green-400">{getAnnualSavings("Growth")}</div>
              )}
            </div>
          </div>

          {/* Premium Option */}
          <div
            className={`flex items-center justify-between space-x-2 p-4 rounded-lg cursor-pointer ${
              selectedOption === "Premium" ? "bg-[#620984]" : ""
            }`}
            onClick={() => handleSelection("Premium")}
          >
            <div className="text-lg font-semibold">Premium</div>
            <div>
              <div className="text-lg font-semibold">
              ₹{(planPricing.Premium[billingCycle === "monthly" ? "monthly" : "annually"] / (billingCycle === "monthly" ? 1 : 12)).toFixed(2)} /month
              </div>
              {billingCycle === "annually" && (
                <div className="text-sm">(annual charge of ₹{planPricing.Premium.annually})</div>
              )}
              {getAnnualSavings("Premium") && billingCycle === "annually" && (
                <div className="text-xs text-green-400">{getAnnualSavings("Premium")}</div>
              )}
            </div>
          </div>

          {/* Enterprise Option */}
          <div
            className={`flex items-center justify-between space-x-2 p-4 rounded-lg cursor-pointer ${
              selectedOption === "Enterprise" ? "bg-[#620984]" : ""
            }`}
            onClick={() => handleSelection("Enterprise")}
          >
            <div className="text-lg font-semibold">Enterprise</div>
            <div className="text-lg font-semibold">Contact Sales</div>
          </div>

          {/* Continue/Upgrade Button with Loading State */}
          <button
            className="mt-6 w-full bg-[#9423bb] py-2 rounded text-lg font-bold flex items-center justify-center"
            onClick={handleContinue}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                PROCESSING...
              </>
            ) : (
              current_subscription ? "UPGRADE" : "GET STARTED"
            )}
          </button>
          
          {/* Email notification info */}
          <div className="mt-4 text-sm text-gray-400">
            <p className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              We'll send confirmation to your email
            </p>
            {selectedOption !== "Free" && (
              <p className="flex items-center mt-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  You'll receive a reminder 7 days before renewal
                </p>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProUpgradeCard;